import _get from "lodash/get";
import { AnyAction } from "redux";
import { VERIFICATION_TARGET } from "../../../../../constants";
import { VerificationState } from "../../../../../models/state";
import * as AUTH_AT from "../../../authentication/state/actionTypes";
import { pending, fulfilled, rejected } from "../../utils";
import * as AT from "../actionTypes";
import * as AT_B2B from "../actionTypesB2B";

const initialState = (): VerificationState => ({
    [VERIFICATION_TARGET.TRANSFER_OWNERSHIP_TO_B2C]: false,
    [VERIFICATION_TARGET.FORMER_LEGAL_OWNER_CONSENT_TRANSFER_B2B]: false,
    [VERIFICATION_TARGET.FORMER_LEGAL_OWNER_CONSENT_PORTIN_B2B]: false,
    [VERIFICATION_TARGET.ESIM_INSTALLMENT_B2B]: false,
    isCreditCheckRequired: false,
    isCreditCheckPerformed: false,
    creditCheckMessage: "",
    isReSwitch: false,
    isLegalOwnerConsentRequired: false,
    isOrdererDifferantThanLegalOwner: false,
    setPersonalDetailsSuccess: false,
    isAllowedToProceed: false,
    isDsfMismatch: false,
});

const reducer = (state = initialState(), action: AnyAction): VerificationState => {
    switch (action.type) {
        case pending(AT.CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP):
        case pending(AT.CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP_EXISTING_COMPANY_ADMIN):
        case rejected(AT.CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP):
            return {
                ...state,
                [action.meta.target]: false,
            };
        case fulfilled(AT.CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP_EXISTING_COMPANY_ADMIN):
            return {
                ...state,
                [action.meta.target]: !action.payload.errorMessage,
            };
        case fulfilled(AT.CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP):
            return {
                ...state,
                [action.meta.target]: !action.payload.errorMessage,
                creditCheckMessage:
                    _get(action, "payload.creditcheck.decision") === "OK"
                        ? null
                        : _get(action, "payload.creditcheck.message", ""),
            };

        ///////////////////////////////////////
        // Non-verification specific actions //
        ///////////////////////////////////////
        case fulfilled(AT.CHECKOUT_CHECK_EXISTING_PHONE_NUMBER):
            return {
                ...state,
                isCreditCheckRequired: !!action.payload.isCreditCheckRequired,
                isLegalOwnerConsentRequired: !!action.payload.legalOwnerConsentRequired,
                isOrdererDifferantThanLegalOwner: !!action.payload.isOrdererDifferantThanLegalOwner,
            };
        case fulfilled(AT.CHECKOUT_CHECK_EXISTING_PHONE_NUMBER_TRANSFER_OWNERSHIP):
            return {
                ...state,
                isCreditCheckRequired: !!action.payload.requiresCreditcheck,
                isLegalOwnerConsentRequired: !!action.payload.legalOwnerConsentRequired,
                isAllowedToProceed: !!action.payload.allowedToProceed,
                isDsfMismatch: action.payload.isDsfMismatch,
            };
        case fulfilled(AT.CHECKOUT_SET_PERSONAL_DETAILS):
            return {
                ...state,
                setPersonalDetailsSuccess: action.payload.success,
            };
        case fulfilled(AT.CHECKOUT_SET_SELECTED_ACCOUNT):
            return {
                ...state,
                setSelectedAccountIdSuccess: action.payload.success,
            };
        case fulfilled(AT.CHECKOUT_SET_TRANSFER_OWNER_PERSONAL_DETAILS):
            return {
                ...state,
                setPersonalDetailsSuccess: action.payload.success,
            };
        case fulfilled(AT_B2B.B2B_SUBMIT_MANUAL_ORDER):
            return {
                ...state,
                submitManualOrderSuccess: action.payload.success,
            };
        case fulfilled(AUTH_AT.AUTH_BANK_ID_GRANT):
            return {
                ...state,
                isCreditCheckRequired: action.payload.isCreditCheckRequired,
                isCreditCheckPerformed: action.payload.isCreditCheckPerformed,
                creditCheckMessage: action.payload.creditCheckMessage,
                isAllowedToProceed: action.payload.isAllowedToProceed,
                isDsfMismatch: action.payload.isDsfMismatch,
            };
        // Some extern cases should reset the verification part
        case fulfilled(AT.CHECKOUT_RESET_ORDER):
        case pending(AT.CHECKOUT_CHECK_EXISTING_PHONE_NUMBER):
        case pending(AT.CHECKOUT_SET_MAIN_SUBSCRIPTION):
            return initialState();
        case pending(AT.CHECKOUT_CHECK_EXISTING_PHONE_NUMBER_TRANSFER_OWNERSHIP):
            return {
                ...initialState(),
                isDsfMismatch: state.isDsfMismatch,
            };
        default:
            return state;
    }
};

export default reducer;
